module.exports = __webpack_public_path__ + "img/normal_multiplier_5.eab5753b.png";